/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ModMedOrderMessage = {
    readonly id?: number;
    status?: ModMedOrderMessage.status;
    duplicate_case?: number | null;
    readonly created_at?: string;
}

export namespace ModMedOrderMessage {

    export enum status {
        PENDING = 'pending',
        SUCCESS = 'success',
        ERROR = 'error',
        HOLD = 'hold',
        DROPPED = 'dropped',
    }


}
